import styled from "styled-components";

const ActionsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 10px;
    margin-top: 10px;
`;

const Actions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 10px;

    svg {
        margin-right: 12px;
    }

    span {
        cursor: pointer;
    }
`;

export { ActionsWrapper, Actions };
